import React from "react"
import classNames from "classnames"

const Email = ({ email, textOnly, className, language }) => {
  const mailTo = `mailto:${email}`

  const classes = classNames(className, {
    email: true,
    email__link: !textOnly
  })

  return (
    <>
      {textOnly ? (
        <p className={classes}>{email}</p>
      ) : (
        <a href={mailTo} title="Send us an email" className={classes}>
          {email}
        </a>
      )}
    </>
  )
}

export default Email
